var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.14,2H7.86L2,7.86v8.28l.9,.9L.21,23.79l6.75-2.7,.9,.9h8.28l5.86-5.86V7.86l-5.86-5.86Zm-6.6,16.37l-3.45-3.45v-1.69h2v.86l2.28,2.28h3.22l2.27-2.28v-.86h2v1.69l-3.45,3.45h-4.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/1765983986/media/icon-help.db0e040d7f20642d8c8d53f5deb801bc.svg";
export { ForwardRef as ReactComponent };